<template>
    <div class="main-content">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: type == 1 ? '/participation/exam' : '/participation/exercise' }">{{ type ==
                '1'
                ?
                '考试' : '练习' }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{ type == '1' ? '考试' : '练习' }}进行中...</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="main-table">
            <el-card class="box-card ">
                <div slot="header" class="clearfix d-flex flex-align-center flex-justify-between">
                    <div class="d-flex flex-column ">
                        <span class="header-title">{{ type == '1' ?
                            examItem.examName : '练习' }}</span>
                        <span class="col-f41" v-if="type == 1">注意：如中途离开/刷新考试界面，此次考试将直接提交</span>
                    </div>
                    <div>
                        <el-button style="float: right; padding: 3px 0" v-if="type == 2" type="text" @click="goBack()"
                            class="mg-lef20">返回</el-button>
                        <el-button style="float: right; padding: 3px 0" v-if="type == 2" type="text"
                            @click="restExercise()">重置</el-button>
                        <el-button style="float: right; padding: 3px 0;font-size: 30px;"
                            v-if="type == 1 && examItem.examStatus !== 'finished'" type="text"
                            @click="beforeSubmitExam(true)">提交试卷</el-button>
                    </div>
                </div>
                <div class="d-flex flex-align-center flex-justify-between ht-100">
                    <div class="topic d-flex flex-column ">
                        <h2>{{ questionItem.questionTypeText }}题</h2>
                        <div class="topic-content flex-1">
                            <div class="topic-title fz22">
                                {{ questionIndex + 1 }}.{{ questionItem.questionTopic }}（{{ questionItem.questionScore
                                }}分）
                            </div>
                            <div class="mg-tp10" v-if="questionItem.questionImg">
                                <img :src="questionItem.questionImg" style="max-width: 200px;" alt="" srcset="">
                            </div>

                            <div class="topic-option">
                                <template v-if="questionItem.questionType == 1">
                                    <el-radio-group v-model="questionItem.myAnswer" class="d-flex flex-column">
                                        <el-radio :label="key" class="mg-tp5 "
                                            v-for="(value, key) of questionItem.questionOption" :key="key">
                                            {{ key }}、{{ value }}
                                        </el-radio>
                                    </el-radio-group>
                                </template>
                                <template v-else-if="questionItem.questionType == 3">
                                    <el-radio-group v-model="questionItem.myAnswer">
                                        <el-radio-button :label="true">正确</el-radio-button>
                                        <el-radio-button :label="false">错误</el-radio-button>
                                    </el-radio-group>
                                </template>
                                <template v-else-if="questionItem.questionType == 2">
                                    <el-checkbox-group v-model="questionItem.myAnswer" class="d-flex flex-column">
                                        <el-checkbox class="mg-tp5 " v-for="(value, key) of questionItem.questionOption"
                                            :key="key" :label="key"> {{ key }}、{{ value
                                            }}</el-checkbox>
                                    </el-checkbox-group>
                                </template>
                            </div>
                        </div>

                        <div class="topic-answer"
                            v-if="questionList[questionIndex] && questionList[questionIndex].myAnswer != null && type == 2">
                            <div>
                                我的答案：{{ getAnswer(questionList[questionIndex])
                                }}
                            </div>
                            <div>
                                正确答案：
                                {{ getQuestionAnswer(questionList[questionIndex])
                                }}

                            </div>
                        </div>
                        <div class="topic-btn d-flex flex-align-center flex-justify-between">
                            <el-button type="primary" :disabled="questionIndex == 0"
                                @click="prevTopic()">上一题</el-button>
                            <div>
                                <el-button type="primary" :disabled="questionIndex == questionList.length - 1"
                                    @click="nextTopic()">下一题</el-button>
                                <el-button type="success" v-if="type == '2'" @click="confirmExercise()">确认</el-button>
                            </div>
                        </div>
                    </div>
                    <div class="overview d-flex flex-column flex-align-center ">
                        <template v-if="type == 1">
                            <i class="el-icon-timer " style="font-size: 130px;"></i>
                            <div class="fz32 mg-tp15">总剩余时间</div>
                            <div class="fz30 mg-tp15">{{ countDown }}</div>
                            <hr style="width: 100%;" class="mg-tp15" />
                        </template>
                        <div class="fz30 mg-tp15">答题进度：{{ questionIndex + 1 }}/{{ questionList.length }}</div>
                        <div class="fz30 mg-tp15">完成率：{{ getRateCompletion() }}%</div>
                        <div class="fz32 mg-tp15">题卡</div>
                        <div class="tpoic-status mg-tp15">
                            <label class="d-flex flex-align-center fz28">已做 <div class="active"></div></label>
                            <label class="d-flex flex-align-center fz28">未做 <div></div></label>
                        </div>
                        <div class="tpoic-num mg-tp5">
                            <div v-for="(item, index) in questionList" :key="item.questionId"
                                :class="{ 'active': item.myAnswer != null }">
                                {{ index + 1 }}</div>
                        </div>

                    </div>
                </div>
            </el-card>
        </div>
        <el-dialog title="考试结束" :visible.sync="topicDialog.visible" custom-class="form-dialog" width="70%"
            @close='closeTopicDialog("edit")'>
            <div class="d-flex flex-column flex-align-center">
                <span class="fz36">交卷成功</span>
                <span class="fz26">本次成绩为{{ examResult.examScore }}分</span>
                <el-form :model="formInline" class="user-search" label-width="120px" style="width: 30%;">
                    <el-form-item label="姓名：">
                        {{ examResult.userName }}
                    </el-form-item>
                    <el-form-item label="考试开始时间：">
                        {{ examResult.examStartTime }}
                    </el-form-item>
                    <el-form-item label="考试结束时间：">
                        {{ examResult.examEndTime }}
                    </el-form-item>
                    <el-form-item label="考试用时：">
                        {{ formatTime(examResult.examConsumeTime) }}
                    </el-form-item>
                </el-form>
                <el-button type="text" @click="showPreview()">试卷详情</el-button>
            </div>

        </el-dialog>
        <preview-papers @close="closePapers" v-bind="previewDialog" :detailFn="detailFn"></preview-papers>

    </div>
</template>

<script>
import previewPapers from '@/components/previewPapers.vue';
import { personalQuestionList, personalQuestionRemove, personalQuestionSubmit } from '@/api/exercise.js'
import { examJoinQuery, commitPaper, examResDetail } from '@/api/takeExam.js'

export default {
    components: {
        previewPapers
    },
    data () {
        return {
            type: '',// 考试类型: 1-考试 2-练习
            radio1: '',
            checkList: [],
            topicDialog: {
                visible: false,

            },
            courseCategoryId: '',
            previewDialog: {
                isPreview: false,
                examId: '',
                visible: false
            },
            countDown: '00:00',
            formInline: {

            },
            countdownInterval: null,
            questionIndex: 0,
            questionList: [],
            questionItem: {
                "answerCorrect": false,//答案是否正确	
                "courseCategoryId": 0,//课程类别id	
                "courseCategoryName": "",//课程类别名称	
                "myAnswer": {},//	我的答案
                answer: null,
                "questionAnalysis": "",//题目解析
                "questionAnswer": {},//答案
                "questionCode": "",//	题目编码
                "questionId": 0,//	题目id
                "questionImg": "",//题目配图
                "questionLanguagePoint": "",//题目知识点
                "questionOption": {},//	题目选项
                "questionScore": 0,//题目分值
                "questionTopic": "",//题目
                "questionType": 0, //	题型:1-单选,2-多选,3-判断
                questionTypeText: '',
            },

            examId: '',
            examItem: {
                examName: '',
                examTimeLength: '',
            },
            examResult: {},
            isMsgBox: false,
        }
    },
    created () {
        this.type = this.$route.query.type;
        if (!this.type) {
            this.$router.go(-1)
        } else {
            if (this.type == 2) {
                this.courseCategoryId = this.$route.query.courseCategoryId;
                this.getExerciseList();

            } else {
                this.examId = this.$route.query.examId;
                this.beginExam();
                window.addEventListener('beforeunload', this.beforeunloadPage, true)
                window.addEventListener('popstate', this.popstatePage, true);
                window.addEventListener("unload", (e) => this.unloadHandler(e));
            }


        };

    },
    mounted () {
        let that = this;
    },
    beforeRouteLeave (to, from, next) {
        if (this.examItem.examStatus == 'finished' || this.type == 2) {
            next();
        } else {
            this.isMsgBox = true;
            this.$msgbox({
                title: '提示',
                message: '离开/退出当前界面，会直接提交该试卷，是否离开？',
                confirmButtonText: '离开',
                showCancelButton: true,
                cancelButtonText: '取消',
                type: 'warning',
                closeOnClickModal: false
            }).then(async () => {
                const res = await commitPaper(this.getParams());
                next();
            }).catch(() => {
                // next();
            })
        }
        this.removeListener();
    },
    methods: {
        // 页面关闭
        async unloadHandler (e) {
            const res = await commitPaper(this.getParams());
            // 退出登录
        },

        removeListener () {
            window.removeEventListener('popstate', this.popstatePage, true);
            window.addEventListener("unload", (e) => this.unloadHandler(e));
            window.removeEventListener('beforeunload', this.beforeunloadPage, true)
        },

        getAnswer (item) {
            const jsonItem = JSON.parse(JSON.stringify(item))
            if (jsonItem.questionType == 2) {
                return typeof jsonItem.myAnswer == 'string' ? jsonItem.myAnswer : jsonItem.myAnswer.join()
            } else if (jsonItem.questionType == 3) {
                if (jsonItem.myAnswer !== null) {
                    return JSON.parse(jsonItem.myAnswer) ? '正确' : '错误'

                } else {
                    return '-'
                }
            } else {
                return jsonItem.myAnswer
            }
        },
        getQuestionAnswer (item) {
            if (item.questionType == 3) {
                if (item.questionAnswer !== null) {
                    return JSON.parse(item.questionAnswer) ? '正确' : '错误'
                } else {
                    return '-'
                }
            } else {
                return item.questionAnswer
            }
        },
        popstatePage () {
            history.pushState(null, null, document.URL)
        },
        async beforeunloadPage (event) {
            event.preventDefault()
            event.returnValue = '';
            return '关闭'
        },
        getRateCompletion () {
            return ((this.questionList.filter(el => el.myAnswer != null).length / this.questionList.length) * 100).toFixed(2)
        },
        getParams () {
            this.setNowQuestionAnswer()
            const params = {
                "answerResList": this.questionList.map(el => {
                    if (el.questionType == 2 && el.myAnswer != null) {
                        el.myAnswer = el.myAnswer.split(',').sort().join()
                    }
                    return {
                        questionId: el.questionId,
                        myAnswer: el.myAnswer == null ? null : el.myAnswer
                    }
                }),
                "examId": this.examItem.examId
            }
            return params
        },
        setNowQuestionAnswer () {
            const nowParams = {
                questionId: this.questionItem.questionId,
                myAnswer: this.questionItem.myAnswer
            }
            if (this.questionItem.questionType == 2) {
                nowParams.myAnswer = nowParams.myAnswer.join(',')
            }
            this.questionList[this.questionIndex] = JSON.parse(JSON.stringify(this.questionItem));
            this.questionList[this.questionIndex].myAnswer = nowParams.myAnswer;
        },
        async getExerciseList () {
            personalQuestionList(this.courseCategoryId).then(res => {
                this.questionIndex = res.data.findIndex(el => el.myAnswer == null);
                if (this.questionIndex == -1) {
                    this.questionIndex = 0
                }
                this.questionList = res.data;
                this.setItem()
            }).catch(err => {
                setTimeout(() => {
                    this.goBack()
                }, 500);
            });

        },
        setItem () {
            this.questionItem = JSON.parse(JSON.stringify(this.questionList[this.questionIndex]));
            if (this.questionItem.questionType == 2) {
                this.questionItem.myAnswer = this.questionItem.myAnswer ? this.questionItem.myAnswer.split(',') : [];
            }
            this.$forceUpdate()
        },
        //练习：选择答案后 就展示正确答案
        async confirmExercise () {
            if (this.questionItem.myAnswer == null) {
                this.$message.warning('请选择答案')
                return
            }
            this.setNowQuestionAnswer()

            const params = {
                questionId: this.questionItem.questionId,
                myAnswer: this.questionItem.myAnswer,
                courseCategoryId:this.courseCategoryId
                
            }
            if (this.questionItem.questionType == 2) {
                params.myAnswer = params.myAnswer.sort().join()
            }
            const res = await personalQuestionSubmit(params);
            if (this.questionIndex < this.questionList.length - 1) {
                // this.questionIndex++;
                // this.setItem()
            } else {
                this.$message.success('所有题目已做完，请点击重置');
            }
            this.$forceUpdate()
        },
        goBack () {
            if (this.examItem.examStatus == 'finished' || this.type == 2) {
                this.$router.push({
                    path: this.type == 1 ? '/participation/exam' : '/participation/exercise'
                })
            } else {
                this.$router.back(-1)
            }
        },
        async restExercise () {
            this.$confirm('是否重置？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const res = await personalQuestionRemove(this.courseCategoryId);
                if (res.code == 200) {
                    this.$message.success('重置成功');
                    this.getExerciseList()
                };
            }).catch(() => {
            });


        },
        //下一题
        nextTopic () {
            if (this.type == 2) {
                if (this.questionList[this.questionIndex].myAnswer != null) {
                    this.questionIndex++;
                    this.setItem();
                } else {
                    this.$message.warning('请先确定答案！')
                }
            } else {
                this.setNowQuestionAnswer()
                this.questionIndex++;
                this.setItem();
            }

        },
        //上一题
        prevTopic () {
            if (this.questionIndex > 0) {
                this.questionIndex--;
                this.setItem();
            }
        },


        //开始考试
        async beginExam () {
            const res = await examJoinQuery(this.examId);
            this.examItem = res.data;
            this.questionList = res.data.questionList;
            this.questionIndex = 0;
            this.setItem();
            if (this.examItem.examStatus == 'finished') {
                const dd = await examResDetail(this.examItem.examId)
                this.removeListener();
                this.examResult = dd.data;
                this.showPreview()
                return
            } else {
                this.startCountdown((Number(res.data.examTimeLength) * 60) - Number(res.data.examConsumeTime))

            }
        },
        beforeSubmitExam (show) {
            this.setNowQuestionAnswer()
            if (this.questionList.some(el => el.myAnswer == null)) {
                this.isMsgBox = true;
                this.$msgbox({
                    title: '提示',
                    message: '当前试卷还有未做的题目，是否确认提交?',
                    showCancelButton: true,
                    confirmButtonText: '提交',
                    cancelButtonText: '继续答题',
                    type: 'warning',
                    beforeClose: (action, instance, done) => {
                        done(); // 就是它!
                    }
                }).then(() => {
                    this.submitExam(show)
                }).catch(() => {
                })

            } else {
                this.submitExam(show)
            }

        },
        async submitExam (show = false) {
            if (this.examItem.examStatus == 'finished') {
                return;
            }
            const res = await commitPaper(this.getParams());
            if (this.isMsgBox) {
                this.$msgbox.close()
            }
            clearInterval(this.countdownInterval);
            this.countdownInterval = null
            this.removeListener();
            if (show == true) {
                this.topicDialog.visible = true;
            } else {
                this.goBack()
            }
            this.examResult = res.data;
            this.examItem.examStatus = res.data.examStatus;
        },
        closeTopicDialog () {
            this.topicDialog.visible = false;
            this.goBack()
        },
        // 倒计时

        startCountdown (seconds) {
            let updateCountdown = () => {
                const minutesDisplay = Math.floor(seconds / 60);
                const secondsDisplay = seconds % 60;
                this.countDown = `${padZero(minutesDisplay)}:${padZero(secondsDisplay)}`
                if (seconds > 0) {
                    seconds--;
                } else {
                    clearInterval(this.countdownInterval);
                    this.submitExam(true)
                }
            };
            let padZero = (number) => {
                return number < 10 ? '0' + number : number;
            };
            // 初始显示
            updateCountdown();
            // 每秒更新显示
            this.countdownInterval = setInterval(updateCountdown, 1000);
        },
        formatTime (seconds) {
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            const remainingSeconds = seconds % 60;
            return `${hours}时${minutes}分${remainingSeconds}秒`;
        },
        showPreview () {
            this.previewDialog.visible = true;
            this.previewDialog.examId = this.examItem.examId;

        },
        detailFn () {
            return examResDetail(this.examItem.examId)
        },
        closePapers () {
            this.previewDialog.visible = false;
            this.goBack()
        }
        //
    },
}
</script>

<style lang="scss" scoped>
.main-table {
    padding: 20px 0;
    box-sizing: border-box;
    overflow: hidden;
}

.box-card {
    height: 100%;
    display: flex;
    flex-direction: column;

    .el-card__body {
        height: 100%;
        flex: 1;
    }
}

.topic {
    border: 1px solid #d8d8d8;
    width: 60%;
    height: 100%;
    padding: 15px;
    box-sizing: border-box;

    h2 {
        margin: 0;
    }
}

.overview {
    border: 1px solid #d8d8d8;
    width: 38%;
    height: 100%;
    padding: 15px;
    box-sizing: border-box;
    font-weight: bold;
    overflow: auto;
    overflow-x: hidden;
}

.header-title {
    font-size: 20px;
    font-weight: bold;
}

.topic-title {
    padding: 10px 0;
}

.topic-option {
    flex-basis: 0;
    overflow-y: auto;
    padding: 10px 0;
    box-sizing: border-box;
}

.tpoic-num {
    display: grid;
    grid-template-columns: repeat(6, 61px);
    grid-row-gap: 20px;
    grid-column-gap: 20px;
    // max-height: 500px;
    // overflow-y: auto;

    div {
        width: 61px;
        height: 61px;
        border: 1px solid #d8d8d8;
        box-sizing: border-box;
        line-height: 61px;
        text-align: center;
        font-weight: bold;
        font-size: 14px;

        &.active {
            background-color: rgba(128, 255, 255, 1);
        }
    }
}

.tpoic-status {
    width: 80%;
    justify-content: space-between;
    display: flex;
    align-items: center;

    div {
        width: 61px;
        height: 61px;
        border: 1px solid #d8d8d8;
        box-sizing: border-box;
        line-height: 61px;
        text-align: center;
        font-weight: bold;
        font-size: 14px;
        margin-left: 10px;

        &.active {
            background-color: rgba(128, 255, 255, 1);
        }
    }
}

.clearfix {
    width: 100%;
}

.topic-answer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    padding: 15px 10px;
    background: rgba(196, 196, 196, 0.16);
    border-radius: 10px;
    color: rgba(215, 0, 15, 0.75);
    font-size: 18px;
}

.topic-content {
    flex-basis: 0;
    overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/views/participation/underway.vue